module.exports = __webpack_public_path__ + "static/blog04-1786b0b75b9be987824c2d3206d0b1c0.png";